import { createSlice } from "@reduxjs/toolkit";
import axios, { API_ENDPOINTS } from "src/utils/axios";

export const initialState = {
  roles: [],
  message: null,
};

const slice = createSlice({
  name: "role",
  initialState,
  reducers: {
    getRolesStart(state) {
      state.roles = [];
      state.message = null;
    },
    getRolesSuccess(state, action) {
      state.roles = action.payload;
      state.message = null;
    },

    getRolesFailure(state, action) {
      state.roles = [];
      state.message = "Failed to fetch roles";
    },
  },
});

export const { getRolesSuccess, getRolesFailure } = slice.actions;

export default slice.reducer;

export function getRoles(params={}) {
  return async (dispatch) => {
    dispatch(slice.actions.getRolesStart());
    try {
      const response = await axios.get(API_ENDPOINTS.role.list, {params});

      dispatch(slice.actions.getRolesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.getRolesFailure());
    }
  };
}
